<template>
  <div>
    
    <div>
        
        <el-upload
            class="ss-img-avatar-uploader"
            action
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onFileChange">

            <span class="caixa-remove" v-if="value">
                <i class="fa fa-times-circle" v-on:click.stop="removeImage()"></i>
            </span>

            <img v-if="value && !image" :src="value | image('filters:max_bytes(102400)')" class="img-avatar">
            
            <span v-if="image && value" class="img-selected">1 imagem selecionada</span>
            
            <i v-if="!value && !image" class="el-icon-plus ss-img-avatar-uploader-icon"></i>
        
        </el-upload>
    </div>
    

  </div>
</template>

<script>

export default {
  name: 'input-image',
  props: ['value', 'maxBytes'],
  data () {
    return {
      image: '',
      updateFile: false,
    }
  },
  methods: {
    onRemove(file, fileList) {
        
        this.image = null;
        this.$emit('input', '');
    },
    onFileChange(e) {
        
        if(!e.raw)
            return false;

        if(e.raw.type != 'image/png' && e.raw.type != 'image/jpeg'){
            this.image = null;
            this.$emit('input', '');
            this.$emit('erro', 'Ops! Apenas arquivos do tipo png e jpeg são permitidos.');
            return false;
        }

        if(this.maxBytes && e.raw.size > this.maxBytes){
            this.image = null;
            this.$emit('input', '');
            this.$emit('erro', 'Ops! A imagem selecionada ultrapassou o tamanho máximo permitido em MB.');
            return false;
        }

        this.image = null;

        this.updateFile = true;
        this.$emit('erro', '');
        this.$emit('input', e.raw);
        this.image = URL.createObjectURL(e.raw);

    },
    removeImage(){

        this.image = null;
        this.$emit('delete');
    }
  },
}
</script>
<style>

    .ss-img-avatar-uploader{
        margin-top: 10px;
    }

    .ss-img-avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        max-width: 180px;
        margin: auto;
        height: 105px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .ss-img-avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .ss-img-avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        max-width: 300px;
        text-align: center;
    }
    .img-selected{
        color: #8c939d;
        line-height: 180px;
        text-align: center;
        display: block;
    }
    .img-avatar {
        display: block;
        max-width: 100%;
        height: auto;
    }
    .caixa-remove i{
        cursor:pointer; 
        position: absolute; 
        right: 5px; 
        top: 4px; 
        font-size: 15px; 
        color: #000;
        background-color: #fff;
        border-radius: 50%;
    }

  
</style>